export function initTinyMceCharacterCount(editor, maxCharacterCount, infoElementSelector) {
    //NOTE: infoElementSelector must be a div, span etc, not a label
    //using keydown and keyup for the best possible ux
    editor.off('keydown').on('keydown', function (e) {
        var length = editor.contentDocument.body.innerText.length;

        if (e.keyCode === 8) {
            //handle backspace 
            return;
        }

        if (length === maxCharacterCount) {
            e.stopPropagation();
            e.preventDefault();
            e.returnValue = false;
            e.cancelBubble = true;
            return false;
        }
    });
    editor.off('keyup').on('keyup', function (e) {
        var length = editor.contentDocument.body.innerText.length;
        var displayElement = $(infoElementSelector);

        if (e.keyCode === 8 && length === maxCharacterCount) {
            //handle backspace                    
            displayElement.html(maxCharacterCount - 1 + " of " + maxCharacterCount + " characters used.");
            return;
        }

        tinymceCharCountDisplayWorker(displayElement, length, maxCharacterCount);
    });
    setTimeout(function () {
        //displays the current count on page load
        var length = editor.contentDocument.body.innerText.length;
        var displayElement = $(infoElementSelector);
        tinymceCharCountDisplayWorker(displayElement, length, maxCharacterCount);
    }, 500);
}

function tinymceCharCountDisplayWorker(displayElement, currentCharCount, maxCharacterCount) {
    if (currentCharCount < maxCharacterCount) {
        displayElement.html(currentCharCount + " of " + maxCharacterCount + " characters used.");
    } else {
        displayElement.html("Maximum character count (" + maxCharacterCount + ") reached.");
    }
}